import { IIndusService } from "./IIndusService"
import ApiUtils from "../ApiUtils"
import { IFilterProductsParams, IFilterProductsResponse } from "../../interfaces/api/indus/IProduct"
import { IUpdateGlpDeliveryDatePayload, IUpdateGlpDeliveryDateResponse } from "../../interfaces/api/indus/updateGlpDeliveryDate"
import { IFetchDetailedOrderPayload, IFetchDetailedOrderResponse } from "../../interfaces/api/indus/orderDetailed"
import { ISearchOrdersPayload, ISearchOrdersResponse } from "../../interfaces/api/indus/SearchOrder"
import { IGetOrderAllResponse } from "../../interfaces/api/indus/GetOrderAll"

const IndusUrls = {
	filterProduct: `/product/filter`,
	updateGlpDeliveryDate: `/external_provider/manual/3p/updateDeliveryDate`,
	fetchDetailedOrder: `/order/detailed`,
	searchOrders: `/order/search/v2`,
	getOrderAll: `/order/all`,
}
export default class IndusServiceApis implements IIndusService {
	getServiceUrl = (url: string) => `/indus${url}`
	filterProducts = (params: IFilterProductsParams): Promise<IFilterProductsResponse> => {
		return ApiUtils.post(this.getServiceUrl(IndusUrls.filterProduct), params)
	}
	updateGlpDeliveryDate = (payload: IUpdateGlpDeliveryDatePayload): Promise<IUpdateGlpDeliveryDateResponse> => {
		return ApiUtils.post(this.getServiceUrl(IndusUrls.updateGlpDeliveryDate), payload)
	}
	fetchDetailedOrder = ({ cfOrderId }: IFetchDetailedOrderPayload): Promise<IFetchDetailedOrderResponse> => {
		const url = this.getServiceUrl(IndusUrls.fetchDetailedOrder) + `?${ApiUtils.requestToQueryParams({ cfOrderId })}`
		return ApiUtils.get(url)
	}
	searchOrders = (payload: ISearchOrdersPayload): Promise<ISearchOrdersResponse> => {
		return ApiUtils.post(this.getServiceUrl(IndusUrls.searchOrders), payload)
	}
	getOrderAll = (userId: string, pageSize: number, pageNo: number): Promise<IGetOrderAllResponse[]> => {
		return ApiUtils.get(this.getServiceUrl(IndusUrls.getOrderAll) + `?${ApiUtils.requestToQueryParams({ userId, pageSize, pageNo })}`)
	}
}
